import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  name = "HBB0011 REALTY",
  type = "website",
  image = "https://hbb0011realty.com/logo.png",
  url = "https://hbb0011realty.com",
  isHome = false
}) => {
  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={name} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Structured Data for LocalBusiness (Only on Home Page) */}
      {isHome && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "RealEstateAgent",
            "name": name,
            "image": image,
            "@id": url,
            "url": url,
            "telephone": "+919916710011",
            "email": "info@hbb0011realty.com",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "India",
              "addressCountry": "IN"
            },
            "sameAs": [
              "https://www.facebook.com/hbb0011realty",
              "https://www.instagram.com/hbb0011realty",
              "https://www.linkedin.com/company/hbb0011realty"
            ]
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
